import { render, staticRenderFns } from "./SubscriptionOptionsFaq.vue?vue&type=template&id=0a721c05&"
import script from "./SubscriptionOptionsFaq.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionOptionsFaq.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionOptionsFaq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports